import BasketHeadline from './basketHeadline';

export default class BasketHeadlineDesktop extends BasketHeadline {
}
